// extracted by mini-css-extract-plugin
export default {"containerResponsive":"styles_containerResponsive__mxh+I"};